import React from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

// eslint-disable-next-line no-unused-vars
const WrapperCardInfo = ({ t, title, color }) => {
  return (
    <div className={`wrapper-card-info ${color}`}>
      <span className={`title ${color}`}>{title}</span>
    </div>
  );
};

WrapperCardInfo.propTypes = {
  t: PropTypes.func.isRequired,
  title: PropTypes.oneOfType([PropTypes.element, PropTypes.string]).isRequired,
  color: PropTypes.string,
};

WrapperCardInfo.defaultProps = {
  color: 'default',
};

export default withTranslation('common')(WrapperCardInfo);
